import { boolean, number, object, string } from 'yup';

export const optionItemValidation = object().shape({
  nameHE: string().required('שדה חובה'),
  nameEN: string().required('שדה חובה'),
  isActive: boolean(),
});
